import router from '@/js/router';
import axios from "axios";
import md5 from "@/js/md5utf8.js";
import api from '@/js/api';
/*global mui,stopOne*/
export default {
    refreshTime: 5000,
    timeOut1: null,
    timeOut2: null,
    timeOut3: null,
    timeOut4: null,
    user: JSON.parse(sessionStorage.getItem("user")),

    refreshUserInfo(callback) {
        let params = {}
        this.setDnValueUser(params);
        let withdraw_money = 0
        axios.get(api.api_getOneNotFinishWithdraw, { params: params }).then(res=>{
            if(res.data.data.withdraw_money) {
                withdraw_money = res.data.data.withdraw_money
            }
            axios.get(api.api_getUserByUserId, { params: params }).then(res => {
                if (res.data.code == 0) {
                    let newData = [res.data.data].map(item => {
                        return {
                            id: item.id,
                            user_id: item.user_id,
                            phone: item.phone,
                            login_name: item.login_name,
                            nick_name: item.nick_name,
                            status: item.status,
                            has_pay_password: item.has_pay_password,
                            sex: item.sex,
                            level: item.level,
                            email: item.email,
                            ico_picture_img: require('@/assets/images/avater/' + item.ico_picture + '.png'),
                            ico_picture: item.ico_picture,
                            money: item.money.toFixed(2),
                            frozen_money: (item.frozen_money - withdraw_money).toFixed(2),
                            integral: item.integral,
                            remark: item.remark,
                            sign_days: item.sign_days,
                            last_sign_time: item.last_sign_time,
                            is_sign: item.is_sign,
                            token: this.user.token,
                            invite_code: parseInt(item.user_id) + 100000,
                            vip_level: item.vip_level
                        };
                    });
                    this.user = newData[0];
                    sessionStorage.setItem("user", JSON.stringify(newData[0]));
                    if (typeof callback == "function") {
                        callback(newData[0]);
                    }
                } else {
                    this.checkToken(res.data.message);
                }
            });
        }).catch(()=>{
            axios.get(api.api_getUserByUserId, { params: params }).then(res => {
                if (res.data.code == 0) {
                    let newData = [res.data.data].map(item => {
                        return {
                            id: item.id,
                            user_id: item.user_id,
                            phone: item.phone,
                            login_name: item.login_name,
                            nick_name: item.nick_name,
                            status: item.status,
                            has_pay_password: item.has_pay_password,
                            sex: item.sex,
                            level: item.level,
                            email: item.email,
                            ico_picture_img: require('@/assets/images/avater/' + item.ico_picture + '.png'),
                            ico_picture: item.ico_picture,
                            money: item.money,
                            frozen_money: item.frozen_money - withdraw_money,
                            integral: item.integral,
                            remark: item.remark,
                            sign_days: item.sign_days,
                            last_sign_time: item.last_sign_time,
                            is_sign: item.is_sign,
                            token: this.user.token,
                            invite_code: parseInt(item.user_id) + 100000,
                            vip_level: item.vip_level
                        };
                    });
                    this.user = newData[0];
                    sessionStorage.setItem("user", JSON.stringify(newData[0]));
                    if (typeof callback == "function") {
                        callback(newData[0]);
                    }
                } else {
                    this.checkToken(res.data.message);
                }
            });
        })
        
    },
    handleDownloadQrIMg(qrBase64) {
        // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
        const imgUrl = qrBase64;
        // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
        if (window.navigator.msSaveOrOpenBlob) {
            const bstr = atob(imgUrl.split(',')[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            const blob = new Blob([u8arr])
            window.navigator.msSaveOrOpenBlob(blob, 'coin01' + '.' + 'png')
        } else {
            // 这里就按照chrome等新版浏览器来处理
            const a = document.createElement('a')
            a.href = imgUrl
            a.setAttribute('download', 'coin01')
            a.click()
        }
    },
    onCopy() {
        mui.toast("Copy succeeded");
    },
    onError() {
        mui.toast("Copy failed");
    },
    outline() {
        let groupUserId = localStorage.getItem("groupUserId");
        if (groupUserId != null) {
            console.log(groupUserId + " Get off the line");
            stopOne(groupUserId);
            localStorage.removeItem("groupUserId");
        }
    },
    objArraySort(objArr, sortParam) {
        let list = [];
        if (objArr.length === 0) return list;
        if (Object.keys(sortParam).length === 0) return objArr;
        let key = sortParam.key;
        let result = objArr.slice(0);
        if (key == 'name') {
            if (sortParam.asc) list = result.sort((a, b) => a[key].localeCompare(b[key]));
            else list = result.sort((a, b) => b[key].localeCompare(a[key]));
        } else {
            if (sortParam.asc) list = result.sort((a, b) => a[key] - b[key]);
            else list = result.sort((a, b) => b[key] - a[key]);
        }
        return list;
    },
    isLogin() {
        if (sessionStorage.getItem("user") != null) return true;
        this.topage("login");
        return false;
    },
    goblack() {
        window.history.back();
    },
    checkToken(msg) {
        if (msg.search("token") != -1) {
            console.log(msg);
            sessionStorage.removeItem("user");
            this.topage("login");
            if (msg == 'member token is invalid') mui.alert("You are already signed in on another device");
        } else {
            mui.alert(msg);
        }
    },
    topage(path, name, name_2) {
        window.clearTimeout(this.timeOut1);
        window.clearTimeout(this.timeOut2);
        window.clearTimeout(this.timeOut3);
        window.clearTimeout(this.timeOut4);
        if (path == router.currentRoute.path || path == router.currentRoute.name) return;
        if (path != "chat") this.outline();
        if (name) {
            router.push({ path: path, query: { name: name, name_2: name_2 } });
        } else {
            router.push(path);
        }
    },
    setDnValueUser(params) {
        params.userId = this.user.user_id;
        params.userName = this.user.login_name;
        params.userToken = this.user.token;
        this.setDnValue(params);
    },
    setDnValueToken(params) {
        params.userName = this.user.login_name;
        params.userToken = this.user.token;
        this.setDnValue(params);
    },
    setDnValue(params) {
        let sort_params = this.strSort(this.encodeSearchParams(params));
        params.dn_value = md5.md5_hex_utf8(sort_params);
    },
    get_dn_value(params) {
        let sort_params = this.strSort(this.encodeSearchParams(params));
        return md5.md5_hex_utf8(sort_params);
    },
    strSort(str) {
        let arr = str.split("&");
        return arr.sort().join("&");
    },
    encodeSearchParams(obj) {
        const params = []
        Object.keys(obj).forEach((key) => {
            let value = obj[key];
            if (typeof value === 'undefined') value = '';
            params.push([key, value].join('='))
        })
        return params.join('&')
    },
    replacetime(time) {
        time = time.replace(/-/g, "/");
        return new Date(time).getTime();
    },
    isPC() {
        let info = navigator.userAgent;
        let isPhone = /mobile/i.test(info);
        return !isPhone;
    },
    formatTime(timestamp) {
        if (typeof timestamp === 'string') {
            timestamp = Number(timestamp);
        }
        if (typeof timestamp !== 'number') return "";
        if (timestamp == 0) return "";
        let date = new Date(timestamp * 1000);
        let M = String(date.getMonth() + 1).padStart(2, '0');
        let D = String(date.getDate()).padStart(2, '0');
        let h = String(date.getHours()).padStart(2, '0');
        let m = String(date.getMinutes()).padStart(2, '0');
        let s = String(date.getSeconds()).padStart(2, '0');
        return date.getFullYear() + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
    },
    formatTimeEn(timestamp) {
        if (typeof timestamp === 'string') {
            timestamp = Number(timestamp);
        }
        if (typeof timestamp !== 'number') return "";
        if (timestamp == 0) return "";
        let date = new Date(timestamp * 1000);
        let Y = date.getFullYear() + ' ';
        let M = this.turnMonth(date.getMonth() + 1) + ' ';
        let D = date.getDate() + ' ';
        let h = date.getHours() + ':';
        let m = date.getMinutes() + ':';
        let s = date.getSeconds();
        return M + D + Y + h + m + s;
    },
    getCurrentTime() {
        let date = new Date();
        let M = this.turnMonth(date.getMonth() + 1);
        let D = String(date.getDate()).padStart(2, '0');
        let h = String(date.getHours()).padStart(2, '0');
        let m = String(date.getMinutes()).padStart(2, '0');
        let sxw = "Morning ";
        if(parseInt(h)>12 && parseInt(h)<18) sxw = "Afternoon ";
        if(parseInt(h)>=18) sxw = "Night ";
        let str = [M + " " + D + " " + sxw+h + ":" + m, date.getTime / 1000];
        return str;
    },
    turnMonth(num) {
        if (num == 1) return "January";
        if (num == 2) return "February";
        if (num == 3) return "March";
        if (num == 4) return "April";
        if (num == 5) return "May";
        if (num == 6) return "June";
        if (num == 7) return "July";
        if (num == 8) return "Auguest";
        if (num == 9) return "September";
        if (num == 10) return "October";
        if (num == 11) return "November";
        if (num == 12) return "December";
        return "";
    },
    formatDecimal2(value, num) {
        if (value == undefined) return 0;
        let v = 10 * num;
        return Math.floor(value * v) / v;
    },
    formatDecimal1(value, num) {
        return Number(value).toFixed(num);
    },
    randomNum(minNum, maxNum) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            default:
                return 0;
        }
    },
    getWeekInfo(num) {
        if (num == 1) return "Monday";
        if (num == 2) return "Tuesday";
        if (num == 3) return "Wednesday";
        if (num == 4) return "Thursday";
        if (num == 5) return "Friday";
        if (num == 6) return "Saturday";
        if (num == 0) return "Sunday";
        return "";
    },
    // 数字转换
    numberFormat(value) {
        value = value - 0;
        let k = 10000, sizes = ["", "万", "亿", "万亿"], i;
        if (value >= k) {
            i = Math.floor(Math.log(value) / Math.log(k));
            value = value / Math.pow(k, i);
            value = value + sizes[i];
        }
        return value;
    },
    todayTime(type) {
        let start = 0;
        let end = 0;
        if (type == 1) { //for 1 day
            start = this.convertDateFromString(this.getBeforeDate(0), 1);
            end = this.convertDateFromString(this.getBeforeDate(0), 2);
        } else if (type == 2) { //for 2 day
            start = this.convertDateFromString(this.getBeforeDate(1), 1);
            end = this.convertDateFromString(this.getBeforeDate(1), 2);
        } else if (type == 3) { //for 7 day
            start = this.convertDateFromString(this.getBeforeDate(7), 1);
            end = this.convertDateFromString(this.getBeforeDate(0), 2);
        } else if (type == 4) { //for 1 month
            start = this.convertDateFromString(this.getBeforeDate(30), 1);
            end = this.convertDateFromString(this.getBeforeDate(0), 2);
        } else if (type == 5) { //for 3 month
            start = this.convertDateFromString(this.getBeforeDate(90), 1);
            end = this.convertDateFromString(this.getBeforeDate(0), 2);
        } else if (type == 6) { //for until today
            start = 0;
            end = this.convertDateFromString(this.getBeforeDate(0), 2);
        }
        return { startTime: start, endTime: end };
    },
    getBeforeDate(n) {
        let d = new Date();
        let year = d.getFullYear();
        let mon = d.getMonth() + 1;
        let day = d.getDate();
        if (day <= n) {
            if (mon > 1) mon = mon - 1;
            else {
                year = year - 1;
                mon = 12;
            }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = String(d.getMonth() + 1).padStart(2, '0');
        day = String(d.getDate()).padStart(2, '0');
        return year + "-" + mon + "-" + day;
    },
    convertDateFromString(dateString, type) {
        if (dateString) {
            let ts = type == 1 ? " 00:00:00" : " 23:59:59";
            let timestamp = Date.parse(new Date(dateString + ts));
            return timestamp / 1000;
        }
        return 0;
    },
}